<span
  data-test="UGGqpQL3"
  class="items-table__sort"
  [ngClass]="{
    down: ascOrder,
    active: active
  }"
  (click)="onSort()"
>
  <ng-content></ng-content>
</span>
